export type AuthProviderId = 'google' | 'facebook' | 'apple'

export interface AuthProviderOption {
  id: AuthProviderId
  enabled: boolean
  startPath?: string
}

export const AUTH_PROVIDERS: readonly AuthProviderOption[] = [
  { id: 'google', enabled: true, startPath: '/api/auth/google/start' },
  { id: 'facebook', enabled: false },
  { id: 'apple', enabled: false },
]

export const POST_AUTH_ACTION_KEY = 'aruba-animal-radar:post-auth-action'

export type PostAuthAction = 'lost' | 'sighting'

export function authStartUrl(provider: AuthProviderOption): string | null {
  if (!provider.enabled || !provider.startPath) return null

  const returnTo = `${window.location.pathname}${window.location.search}`
  const params = new URLSearchParams({ return: returnTo })
  return `${provider.startPath}?${params.toString()}`
}
